import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const ZalopayResult = () => {
  return <CommonResult />;
};

export default ZalopayResult;
